import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { InlineDescriptionListItem } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'digihaven-dashboard-header',
    templateUrl: './dashboard-header.component.html'
})
export class DashboardHeaderComponent implements OnInit, OnDestroy {
    private readonly organisationLabel$: ReplaySubject<string> = new ReplaySubject(1);
    private readonly roleLabel$: ReplaySubject<string> = new ReplaySubject(1);
    private readonly firstName$: ReplaySubject<string> = new ReplaySubject(1);

    @Input() welcomeMsg!: string;
    @Input() organisationMsg!: string;
    @Input() roleMsg!: string;

    @Input()
    set organisationLabel(organisation: string) {
        this.organisationLabel$.next(organisation);
    }

    @Input()
    set roleLabel(role: string) {
        this.roleLabel$.next(role);
    }

    @Input()
    set firstName(name: string) {
        this.firstName$.next(name);
    }

    title$!: Observable<string>;
    inlineDescriptionListItems$!: Observable<InlineDescriptionListItem[]>;

    ngOnInit(): void {
        this.setupInlineDescriptionListItemsStream();
        this.setupTitleStream();
    }

    ngOnDestroy(): void {
        this.organisationLabel$.complete();
        this.roleLabel$.complete();
        this.firstName$.complete();
    }

    private setupInlineDescriptionListItemsStream(): void {
        this.inlineDescriptionListItems$ = combineLatest([this.organisationLabel$, this.roleLabel$]).pipe(
            map(([organisationLabel, roleLabel]) => {
                return [
                    {
                        details: roleLabel,
                        term: this.roleMsg,
                        icon: {
                            iconOnly: true,
                            name: 'user'
                        }
                    },
                    {
                        details: organisationLabel,
                        term: this.organisationMsg,
                        icon: {
                            iconOnly: true,
                            name: 'building'
                        }
                    }
                ];
            })
        );
    }

    private setupTitleStream(): void {
        this.title$ = this.firstName$.pipe(map(name => `${this.welcomeMsg} ${name}`));
    }
}
